import React, { useCallback, useEffect, useRef, useState } from 'react';
import { dispatcher } from 'dispatcher';
import { QuickDeposit } from '@theme/js/components/main/QuickDeposit/QuickDeposit/QuickDeposit';
import style from './index.scss';
import { scrollService } from 'js/services/scroll.service';
import { useUserSelector } from 'js/store/hooks';
import { pick } from 'ramda';

export const QuickDepositContainer = () => {
    const { isLoggedIn } = useUserSelector(pick(['isLoggedIn']));
    const [isShow, setShow] = useState(false);
    const layerRef = useRef();

    const showPopup = () => {
        setShow(true);
        scrollService.disableBodyScroll();
    };

    const hide = () => {
        setShow(false);
        scrollService.enableBodyScroll();
    };

    const applyAnimation = useCallback(() => {
        if (layerRef) {
            layerRef.current.addEventListener('animationend', hide);
        } else {
            setTimeout(hide, 550);
        }
    }, []);

    const hidePopup = () => {
        setShow('hiding');
        applyAnimation();
    };

    const afterSuccessDeposit = () => {
        dispatcher.dispatch('quickDeposit:updated');
    };

    useEffect(() => {
        dispatcher.listen('quickDeposit:show', showPopup);

        return () => {
            dispatcher.removeListener('quickDeposit:show', showPopup);
        };
    }, [showPopup]);

    useEffect(() => {
        dispatcher.listen('quickDeposit:hide', hidePopup);

        return () => {
            dispatcher.removeListener('quickDeposit:hide', hidePopup);
        };
    }, [hidePopup]);

    if (!isLoggedIn) {
        return null;
    }

    return <div className={`${isShow === 'hiding' ? style.hidingQuickDeposit : isShow === true ? style.showQuickDeposit : ''}`}>
        {isShow && <div ref={layerRef} className={style.layer}>
            <QuickDeposit afterSuccessDeposit={afterSuccessDeposit}/>
        </div>}
    </div>;
};
